import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cb61fd3a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "spend-evolution-vs-prev-period"
};
const _hoisted_2 = {
  class: "spend-evolution-chart"
};
const _hoisted_3 = {
  class: "lastest-value"
};
const _hoisted_4 = {
  class: "historical-value"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "middle-line"
}, null, -1));
const _hoisted_6 = {
  class: "spend-evolution-text"
};
const _hoisted_7 = {
  key: 0,
  class: "negative"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 2,
  class: "negative"
};
const _hoisted_10 = {
  class: "square"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SpendEvolutionCandle = _resolveComponent("SpendEvolutionCandle");
  const _component_app_icon = _resolveComponent("app-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SpendEvolutionCandle, {
    data: $props.spendData[0] ?? $data.defaultData,
    maxValue: $options.maxValue,
    selected_period: $props.selected_period,
    index: $options.arrayRowData.length - 1,
    hovering_index: $props.hovering_index,
    workspace_id: $props.workspace_id,
    seller_id: $props.seller_id,
    hovering_workspace_id: $props.hovering_workspace_id,
    hovering_seller_id: $props.hovering_seller_id,
    top: _ctx.top,
    onDisplayPopover: $options.displayPopover
  }, null, 8, ["data", "maxValue", "selected_period", "index", "hovering_index", "workspace_id", "seller_id", "hovering_workspace_id", "hovering_seller_id", "top", "onDisplayPopover"])]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.arrayRowData.slice(1), (data, index) => {
    return _openBlock(), _createBlock(_component_SpendEvolutionCandle, {
      data: data,
      maxValue: $options.maxValue,
      selected_period: $props.selected_period,
      index: $options.arrayRowData.slice(1).length - index - 1,
      hovering_index: $props.hovering_index,
      workspace_id: $props.workspace_id,
      seller_id: $props.seller_id,
      hovering_workspace_id: $props.hovering_workspace_id,
      hovering_seller_id: $props.hovering_seller_id,
      onDisplayPopover: $options.displayPopover
    }, null, 8, ["data", "maxValue", "selected_period", "index", "hovering_index", "workspace_id", "seller_id", "hovering_workspace_id", "hovering_seller_id", "onDisplayPopover"]);
  }), 256))]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [!$options.lastestValue ? (_openBlock(), _createElementBlock("div", _hoisted_7, "-")) : $options.lastestValue >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, " +" + _toDisplayString(($options.lastestValue * 100).toFixed(0)) + "% ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(($options.lastestValue * 100).toFixed(0)) + "%", 1))]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_app_icon, {
    icon: "dashed-border-fading-right"
  })])]);
}